import {ParametryKwotyDocelowej} from '../../../services/samoobsluga/types/ParametryKwotyDocelowej.interface';

export const parametryKwotyDocelowejStanPoczatkowy: ParametryKwotyDocelowej = {
  kwotaDocelowa: null,
  limitKomeptencyjny: null
}
